import React, { memo } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';

export default memo(({ data }) => {
  return data.map((feat) => {
    const geojson = L.geoJSON(feat);
    const icon = L.divIcon({
      className: 'map-marker',
      html: feat.properties.rank,
      iconSize: [16, 16],
      iconAnchor: [8, 8],
    });
    const center = geojson.getBounds().getCenter();

    return <Marker key={`MapMarker__${feat.properties.rank}`} position={center} icon={icon} />;
  });
});
